module.exports = __webpack_public_path__ + "img/16.e084df94.jpg";